import React, { useState } from 'react';

const updateUser = async (id, userData) => {
    try {
        const response = await fetch(`${import.meta.env.VITE_REACT_APP_BACK_SPRING_USER_ENDPOINT}/users/${id}`, {
            method: 'PUT',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(userData)
        });

        if (response.ok) {
            const data = await response.json();
            console.log("response data : " + JSON.stringify(data));
            // Faire quelque chose avec les données renvoyées par le backend
        } else {
            const text = await response.text();
            console.log("error response text : " + text);
            // Gérer l'erreur et afficher un message d'erreur
        }
    } catch (ex) {
        console.log("ex : " + ex);
        // Gérer l'erreur générale et afficher un message d'erreur
    }
};

const UserUpdate = () => {
    const [id, setId] = useState('');
    const [email, setEmail] = useState('');
    const [firstName, setFirstName] = useState('');
    const [lastName, setLastName] = useState('');
    const [password, setPassword] = useState('');

    const handleSubmit = (event) => {
        event.preventDefault();
        const userData = { email_address: email, first_name: firstName, last_name: lastName, password: password };
        updateUser(id, userData);
    };

    const handleInputChange = (event) => {
        const { name, value } = event.target;
        if (name === 'id') {
            setId(value);
        } else if (name === 'email') {
            setEmail(value);
        } else if (name === 'firstName') {
            setFirstName(value);
        } else if (name === 'lastName') {
            setLastName(value);
        } else if (name === 'password') {
            setPassword(value);
        }
    };

    return (
        <div>
            <form onSubmit={handleSubmit}>
                <div>
                    <label>ID:</label>
                    <input type="text" name="id" value={id} onChange={handleInputChange} />
                </div>
                <div>
                    <label>Email:</label>
                    <input type="text" name="email" value={email} onChange={handleInputChange} />
                </div>
                <div>
                    <label>First Name:</label>
                    <input type="text" name="firstName" value={firstName} onChange={handleInputChange} />
                </div>
                <div>
                    <label>Last Name:</label>
                    <input type="text" name="lastName" value={lastName} onChange={handleInputChange} />
                </div>
                <div>
                    <label>Password:</label>
                    <input type="text" name="password" value={password} onChange={handleInputChange} />
                </div>
                <button type="submit">Update User</button>
            </form>
        </div>
    );
};

export default UserUpdate;
